import { Typography, Row, Col } from 'antd';
import React from 'react'
import { RefLanguage } from '../hooks/LanguageHooks';
import { RefSetCurrentPage } from '../hooks/NavigationHooks';
import * as con from '../Constants';


const { Title, Paragraph, Text, Link } = Typography;


function ExplanationText() {

    const i18n = RefLanguage()
    const navigate = RefSetCurrentPage()

    return (
        <div>
            <Row style={{ marginTop: "0.3vh", padding: "0 2vh" }}>
                <Col span={24}>
                    <Title level={3} style={{ marginTop: "0.3vh", paddingTop: 0 }}>{i18n.t("explanationIntro")}</Title>
                </Col>
            </Row>
            <Typography>
                <Paragraph style={{ textAlign: 'left' }}>
                    {i18n.t("explanationIntroParagraph1")}
                </Paragraph>

                <Paragraph style={{ textAlign: 'left' }}>
                    {i18n.t("explanationIntroParagraph2")}
                    <Text strong>
                        {i18n.t("explanationIntroParagraph2Strong")}
                    </Text>
                </Paragraph>

                <Title level={4}>{i18n.t("explanationFeaturesTitle")}</Title>

                <Paragraph style={{ textAlign: 'left' }}>
                    {i18n.t("explanationFeaturesParagraph")}
                </Paragraph>

                <Paragraph>
                    <ul style={{ textAlign: "left" }}>
                        <li>
                            <Link onClick={() => navigate(con.PAGE_DOCS_METHODS)}>{i18n.t("explanationLinkAnnotationMethods")}</Link>
                        </li>
                        <li>
                            <Link onClick={() => navigate(con.PAGE_DOCS_GETTING_STARTED)}>{i18n.t("explanationLinkGettingStarted")}</Link>
                        </li>
                        <li>
                            <Link onClick={() => navigate(con.PAGE_DOCS_RESOURCES)}>{i18n.t("explanationLinkReferenceDatabases")}</Link>
                        </li>
                    </ul>
                </Paragraph>
            </Typography>


        </div>
    )
}

export default ExplanationText
